import { useIonModal, useIonToast } from '@ionic/react';
import { FullComment } from 'model';
import { useRef, useState } from 'react';
import { useModerateCommentMutation } from '../api/CommentApi';
import { Confirmation } from '../pages/Confirmation';
import { TextArea } from './Forms/TextArea';
import { IconButton } from './IconButton';
import { PostContentsToHTML } from './PostContentsToHTML';
import { ProfilePic } from './ProfilePic';
// eslint-disable-next-line css-modules/no-unused-class
import sharedstyles from '../styles/Shared.module.css';
// eslint-disable-next-line css-modules/no-unused-class
import commentStyles from '../styles/comments.module.css';
import { IconRepeat } from './QuirkIcons';
interface reviseCommentType {
	comment: FullComment;
	action?: () => void;
	label?: string;
}

interface CommentModerationFormProps {
	comment: FullComment;
	updateRevisedComment: (revisedComment: FullComment) => void;
}

export const CommentModerationForm: React.FC<CommentModerationFormProps> = ({ comment, updateRevisedComment }) => {
	const [commentWithMessage, setModalCommentWithMessage] = useState<FullComment>(comment);

	const handleModerationReasonChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		const moderatedComment: FullComment = { ...comment, commentModerationReason: e.target.value || '' };
		setModalCommentWithMessage(moderatedComment);
		updateRevisedComment(moderatedComment);
	};

	return (
		<>
			<div className={sharedstyles.userContainer}>
				<ProfilePic user={comment.fullAuthor} />
				<div className="fullwidth">
					<div>{comment.fullAuthor.username}</div>
				</div>
			</div>
			<div className={commentStyles.commentBox}>
				<PostContentsToHTML>{comment.comment}</PostContentsToHTML>
			</div>
			<div className="space20" />
			<TextArea
				id="description"
				placeholder="Description"
				value={commentWithMessage.commentModerationReason}
				name="description"
				rows={3}
				maxLength={200}
				onChange={handleModerationReasonChange}
				disabled={false}
			/>
		</>
	);
};

export const RequestRevision: React.FC<reviseCommentType> = ({ comment, action, label }) => {
	const [moderateComment] = useModerateCommentMutation();
	const commentWithMessageRef = useRef<FullComment | null>(null);
	const updateRevisedComment = (revisedComment: FullComment) => {
		commentWithMessageRef.current = revisedComment;
	};

	const [present, dismiss] = useIonModal(Confirmation, {
		onDismiss: () => dismiss(),
		action: () => handleRequestRevision(),
		actionLabel: 'Request Revision',
		dismissLabel: 'Cancel',
		content: <CommentModerationForm comment={comment} updateRevisedComment={updateRevisedComment} />
	});

	const [presentRequestRevision] = useIonToast();

	const handleRequestRevision = () => {
		presentRequestRevision({
			color: 'success',
			message: 'Request for revision sent',
			position: 'top',
			duration: 1500
		});
		dismiss();
		moderateComment({ comment: commentWithMessageRef.current || comment });
	};

	return (
		<>
			<IconButton
				label={label}
				icon={<IconRepeat />}
				onClick={() => {
					present();
					action && action();
				}}
			/>
		</>
	);
};
